{
  "pending": "ממתין ל"
}
